import { useState } from 'react'

import { palette } from '../../../../styles/variables'
import { translate } from '../../../../utils/translation'
import {
  isFreeTrialUsed,
  isFreeTrialUser,
} from '../../../../utils/freeVersionBlock'
import { Text } from '../../../topography'
import Modal from '../../Modal'
import { PrimaryButton } from '../../../buttons/Buttons'
import { TIER_TITLES } from '../consts'
import Icon from '../../../icon/Icon'
import successTick from '../../../../styles/assets/checkoutModal/success-tick.png'
import { PROMO_LABEL_VALUE } from '../../../../utils/consts.mjs'

export default ({ isOpen, interval, tier, onClose }) => {
  const [isTrialUsed] = useState(isFreeTrialUsed())

  const getMessage = () => {
    if (!isTrialUsed && isFreeTrialUser() && interval === 'monthly') {
      return {
        title: 'trial_purchase_success',
        subtitle: 'trial_purchase_success_subheading',
      }
    }

    if (interval === 'monthly') {
      return {
        title: 'no_trial_purchase_success',
        subtitle: 'no_trial_purchase_success_subheading',
        tierTitle: TIER_TITLES[tier],
      }
    }

    if (interval === 'yearly') {
      return {
        title: 'yearly_purchase_success',
        subtitle: 'yearly_purchase_success_subheading',
        tierTitle: TIER_TITLES[tier],
      }
    }

    if (interval === PROMO_LABEL_VALUE) {
      return {
        title: 'yearly_purchase_success',
        subtitle: 'bf_bundle_purchase_success_subheading',
      }
    }

    return {
      title: 'lifetime_purchase_success',
      subtitle: 'lifetime_purchase_success_subheading',
      tierTitle: TIER_TITLES[tier],
    }
  }

  const message = getMessage()

  return (
    <Modal
      isOpen={isOpen}
      desktopStyle={{
        width: '95%',
        maxWidth: '512px',
        height: 'fit-content',
        minHeight: '488px',
        overflow: 'unset',
        overflowY: 'auto',
        borderRadius: '4px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        position: 'relative',
        inset: 'auto',
        padding: '0px',
      }}
      overlayStyle={{
        zIndex: 99999,
      }}
    >
      <div
        style={{
          padding: '40px',
          borderBottom: `1px solid ${palette.lightGray50}`,
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'column',
        }}
      >
        <Icon src={successTick} size="64px" />
        <Text
          fontSize="22px"
          lineHeight="38.4px"
          textAlign="center"
          margin={
            message.title === 'trial_purchase_success'
              ? '24px 20px 0 20px'
              : '24px 0 0 0'
          }
          boldColor={palette.darkGray}
          dangerouslySetInnerHTML={{
            __html: translate(message.title),
          }}
        />
        <div
          style={{
            width: '56px',
            borderBottom: `1px solid ${palette.orange}`,
            marginTop: '24px',
          }}
        />
        <Text
          margin="40px 0 0 0"
          fontSize="14px"
          lineHeight="26px"
          textAlign="center"
        >
          {translate(
            message.subtitle,
            message?.tierTitle
              ? message?.tierTitle && translate(message.tierTitle)
              : '',
          )}
        </Text>
      </div>
      <div style={{ padding: '40px', textAlign: 'center' }}>
        <PrimaryButton
          type="button"
          tag={translate('get_started')}
          theme="orange"
          fontSize="14px"
          letterSpacing="0.08em"
          style={{
            lineHeight: 1,
            width: '272px',
            maxWidth: '100%',
          }}
          onClick={onClose}
        />
      </div>
    </Modal>
  )
}
